import { toast } from 'react-toastify'
import { TManualStockCheckStaff } from '@/types'
import { api } from '@/api'
import { NAME_STATUS_API_ORDER } from '../../../apps/Applications/consts'

export const checkManualStockStaff = (data: TManualStockCheckStaff) => {
  const response = api.tariff.checkManualStock(data)
  toast
    .promise(response, {
      pending: NAME_STATUS_API_ORDER.MANUAL_STOCK.PENDING
    })
    .then((res) => {
      if (!res[0].code) {
        toast.error(`${NAME_STATUS_API_ORDER.MANUAL_STOCK.ERROR} ${'Акция не применена!'}`)
      }
    })
    .catch((e) => {
      const { data } = e.response.data
      if (data.code) {
        return NAME_STATUS_API_ORDER.MANUAL_STOCK.SUCCESS
      }
      Object.keys(data[0]).forEach((key) => {
        toast.error(`${NAME_STATUS_API_ORDER.MANUAL_STOCK.ERROR + data[0][key]}`)
      })
      return 0
    })
  return response
}
